<template>
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23 mb-20">클래스 상세정보</p>
                        <a class="float-right layer-close ml-30 pointer" @click="$emit('close')">
                            <img src="../../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <div class="hq-table-row">
                            <table>
                                <colgroup>
                                    <col width="30%">
                                    <col width="70%">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>이름</th>
                                        <td>{{user.name || '-'}}</td>
                                    </tr>
                                    <tr>
                                        <th>이메일</th>
                                        <td>{{subject.email}}</td>
                                    </tr>
                                    <tr>
                                        <th>회사명</th>
                                        <td>{{subject.company_name}}</td>
                                    </tr>
                                    <tr>
                                        <th>언어</th>
                                        <td>{{subject.language}}</td>
                                    </tr>
                                    <tr>
                                        <th>클래스명</th>
                                        <td>{{subject.subject_name || '-'}}</td>
                                    </tr>
                                    <tr>
                                        <th>요일</th>
                                        <td>{{subject.day}}</td>
                                    </tr>
                                    <tr>
                                        <th>교육 시간</th>
                                        <td>{{subject.subject_start_time}} ~ {{subject.subject_end_time}}</td>
                                    </tr>
                                    <tr v-if="subject.price">
                                        <th>결제금액</th>
                                        <td>{{subject.price || '-'}}원</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    props: ['parentData', 'parentUser'],
    data: () => ({
        subject: {}, // 과목 데이터
        user: {}
    }),

    mounted() {
        this.subject = this.parentData
        this.user = this.parentUser
        // console.log('this.subject', this.subject)

        this.subject.day = this.replaceAll(this.subject.day,"^",",");
    },

    methods: {
        // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
        numberFormat(inputNumber) {
            if (inputNumber) {
                return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return 0
            }
        },
        replaceAll(str,searchStr,replaceStr){
            return str.split(searchStr).join(replaceStr);

        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>

